/**
 * On-Site Welder Qualification & Release (LC-36A) — тексты бумажного бланка.
 *
 * ЗЕРКАЛО констант SECTION_* из src/Entity/WelderQualificationRelease.php:
 * PDF и админка рендерят текст оттуда, айпад — отсюда. Меняешь формулировку —
 * меняй в ОБОИХ файлах. Ключи неизменны: по ним лежат ответы отправленных форм.
 */

export const DOCUMENTS_ITEMS = [
    { key: 'idMatches', label: 'Government-issued ID matches submitted qualification records.' },
    { key: 'wpqCurrent', label: 'Welder Performance Qualification (WPQ/WQTR) is current and legible.' },
    { key: 'processCovered', label: 'Qualification covers the production process: SMAW / FCAW / GMAW / other approved process.' },
    { key: 'positionCovered', label: 'Qualification covers required position, pipe/tubular work, diameter and thickness range.' },
    { key: 'continuity', label: 'Six-month process continuity is verified and documented.' },
    { key: 'wpsAvailable', label: 'Approved project WPS is available at the work area; supporting PQR is available when required.' },
    { key: 'materialMatch', label: 'Base material and filler/electrode match the approved WPS and project specifications.' },
];

export const FIELD_VALIDATION_ITEMS = [
    { key: 'qcReviewsQualification', label: "QC/CWI reviews the welder's qualification against the exact production WPS." },
    { key: 'demonstrationCoupon', label: 'Project-specific demonstration/coupon completed when required using representative process, position and joint conditions.' },
    { key: 'testWeldExamined', label: 'Test weld receives required visual examination and NDE/mechanical testing, if specified.' },
    { key: 'welderIdAssigned', label: 'Welder is assigned a unique ID/stamp after acceptance.' },
];

/** Порядок = чтение бумаги по строкам: левая ячейка, потом правая. */
export const PRODUCTION_CONTROL_ITEMS = [
    { key: 'wpsAtWorkFace', label: 'WPS at work face' },
    { key: 'correctFiller', label: 'Correct filler / electrode' },
    { key: 'preheatVerified', label: 'Preheat verified' },
    { key: 'interpassControlled', label: 'Interpass temperature controlled' },
    { key: 'lowHydrogenControlled', label: 'Low-hydrogen consumables controlled' },
    { key: 'jointFitUpAccepted', label: 'Joint fit-up / cope accepted' },
    { key: 'welderIdTraceable', label: 'Welder ID traceable to each weld' },
    { key: 'ndeDocumented', label: 'Required VT / MT / UT / RT documented' },
];

/** Подсказки для поля Process — вписать можно что угодно. */
export const WELDING_PROCESS_OPTIONS = ['SMAW', 'FCAW', 'GMAW', 'GTAW', 'SAW'];

export const GOVERNING_REQUIREMENTS = [
    {
        lead: 'Structural steel/tubular work:',
        text: 'AWS D1.1/D1.1M and project drawings/specifications.',
    },
    {
        lead: 'Pressure/process piping:',
        text: 'applicable ASME B31 code + ASME BPVC Section IX when required by design.',
    },
];

export const GOVERNING_NOTE =
    'ASTM standards define material requirements; they do not replace the applicable AWS/ASME welder and procedure qualifications.';

export const BANNER_TEXT = '***NO PRODUCTION WELDING UNTIL QC/CWI RELEASE IS COMPLETE***';

export const STOP_WORK_TEXT =
    'Any mismatch between the welder qualification, WPS, material, process, position, joint configuration, or required inspection must be resolved by QC/CWI before welding.';

export const FIELD_RULE_TEXT =
    'FIELD RULE: QUALIFIED WELDER + APPROVED WPS + ACCEPTED FIT-UP + REQUIRED INSPECTION = RELEASE TO WELD';

/** {key: false} для всех пунктов секции — стартовое состояние формы. */
export function emptyChecklist(items) {
    return items.reduce((acc, item) => ({ ...acc, [item.key]: false }), {});
}

/** Сколько пунктов отмечено — для прогресса в шапке и в списке. */
export function countChecked(checklist, items) {
    return items.filter((item) => !!checklist?.[item.key]).length;
}

export const TOTAL_CHECKS =
    DOCUMENTS_ITEMS.length + FIELD_VALIDATION_ITEMS.length + PRODUCTION_CONTROL_ITEMS.length;
